import { APP_ROUTES } from "@/Generated/Routes/paths";

import AppRouter from "@/Router";
import { verifyToken } from "@/Services/TherapyApi/Auth";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";
import useAuthStore from "../Store";

import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";

const verifyTokenAH = async (token: string) => {
  const authStore = useAuthStore();

  const resp = await verifyToken(token).catch(() => undefined);

  if (hasValue(resp) && !isApiError(resp) && isValidString(resp.token)) {
    authStore.setUserToken(token);

    AppRouter.push({ name: APP_ROUTES.home.root.name });
  } else {
    AppRouter.push({ name: APP_ROUTES.login.root.name });
  }
};

export default verifyTokenAH;
